// Pure URL generator utilities for different products

import { PATHS } from "@/constants/pathnames";
import { getLocalizedPath } from "./pathUtils";

// Common helpers
const toIsoDate = (date) => {
  if (!date) return "";
  if (typeof date === "string") {
    return date.length > 10 ? date.split("T")[0] : date;
  }
  try {
    return date.toISOString().split("T")[0];
  } catch {
    return "";
  }
};

// Bus
// Expects data: {
//   departureCity: { id, code } | { slug, code },
//   returnCity: { id, code } | { slug, code },
//   departureDate: Date|string,
//   passengers?: { adult, young, child }
// }
export function generateBusSearchUrl(data) {
  if (!data) return "/bus-ticket";
  const fromId =
    data.departureCity?.id ?? data.initialDepartureCitySlug ?? "from";
  const toId = data.returnCity?.id ?? data.initialReturnCitySlug ?? "to";
  const stationInfo = `${fromId}-${toId}`;
  const depDate = toIsoDate(data.departureDate ?? data.initialDepartureDate);

  const params = new URLSearchParams();
  const pax = data.passengers ?? data.initialPassengers;
  if (pax?.adult > 0) params.set("adult", String(pax.adult));
  if (pax?.young > 0) params.set("young", String(pax.young));
  if (pax?.child > 0) params.set("child", String(pax.child));

  const base = `/bus-ticket/one-way/${stationInfo}/${depDate}`;
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function generateFerrySearchUrl(data, locale = "tr") {
  if (!data) return "/ferry";
  const fromId = data.origin?.id ?? "from";
  const toId = data.destination?.id ?? "to";
  const stationInfo = `${fromId}-${toId}`;
  const depDate = toIsoDate(data.departureDate || new Date());
  const retDate = toIsoDate(data.returnDate);
  const params = new URLSearchParams();
  const pax = data.passengers;
  if (pax?.adult > 0) params.set("adult", String(pax.adult));
  if (pax?.child > 0) params.set("child", String(pax.child));
  if (pax?.childAges > 0) params.set("childAges", String(pax.childAges));
  if (pax?.isWithVehicle) params.set("vehicle", String(pax.vehicleType.value));
  let base = "";
  if (retDate) {
    base = getLocalizedPath(PATHS.FERRY_TICKET_ROUND_TRIP.PATH, locale)
      .replace("[stationInfo]", `${stationInfo}`)
      .replace("[departureDate]", depDate)
      .replace("[returnDate]", retDate);
  } else {
    base = getLocalizedPath(PATHS.FERRY_TICKET_ONE_WAY.PATH, locale)
      .replace("[stationInfo]", `${stationInfo}`)
      .replace("[departureDate]", depDate);
  }
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}
// Generic dispatcher (extensible)
export function generateSearchUrl(product, data, locale = "tr") {
  switch (product) {
    case "bus":
      return generateBusSearchUrl(data);
    case "ferry":
      return generateFerrySearchUrl(data, locale);
    default:
      return "/";
  }
}
